// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '/metas',
  component: () => import('modules/goals/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          }
        ]
      },
      name: 'PainelMetas',
      component: () => import('modules/goals/IconList.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'budget',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Budget',
            name: 'Budget'
          }
        ]
      },
      name: 'Budget',
      component: () => import('modules/goals/Budget/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.visualizar_budget')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'budget-anual',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Budget',
            name: 'Budget'
          },
          {
            text: 'Budget Anual',
            name: 'Budget Anual'
          }
        ]
      },
      name: 'Budget Anual',
      component: () => import('modules/goals/Budget/BudgetAnual/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.visualizar_budget')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'importar-meta-macro',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Budget',
            name: 'Budget'
          },
          {
            text: 'Import Meta Macro',
            name: 'Import Macro Goal'
          }
        ]
      },
      name: 'Import Macro Goal',
      component: () => import('modules/goals/Budget/importMacroGoal/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.distribuicao_meta_macro')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'importar-meta-regional',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Budget',
            name: 'Budget'
          },
          {
            text: 'Import Meta Regional',
            name: 'Import View Goal'
          }
        ]
      },
      name: 'Import View Goal',
      component: () => import('modules/goals/Budget/importViewGoal/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.distribuicao_meta_regional')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'ponto-de-venda',
      component: () => import('modules/goals/place/Index.vue'),
      children: [
        {
          path: '',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Metas',
                name: 'PainelMetas'
              },
              {
                text: 'Ajustar Informações de PDV',
                name: 'goalsPlace'
              }
            ]
          },
          name: 'goalsPlace',
          component: () => import('modules/goals/place/List.vue'),
          // eslint-disable-next-line
          beforeEnter: (to, from, next) => {
            if (hasPermission('web.metas.ponto_venda')) {
              next();
            } else {
              next('/');
            }
          }
        },
        {
          path: 'criar',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Metas',
                name: 'PainelMetas'
              },
              {
                text: 'Ajustar Informações de PDV',
                name: 'goalsPlace'
              },
              {
                text: 'Cadastrar Novo PDV',
                name: 'CriarPdvMetas'
              }
            ]
          },
          name: 'CriarPdvMetas',
          component: () => import('modules/goals/place/Create.vue'),
          // eslint-disable-next-line
          beforeEnter: (to, from, next) => {
            if (hasPermission('web.metas.ponto_venda')) {
              next();
            } else {
              next('/');
            }
          }
        },
        {
          path: ':id',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Metas',
                name: 'PainelMetas'
              },
              {
                text: 'Editar Ponto de Venda',
                name: 'EditarPdvMetas'
              }
            ]
          },
          name: 'EditarPdvMetas',
          component: () => import('modules/goals/place/Edit.vue'),
          // eslint-disable-next-line
          beforeEnter: (to, from, next) => {
            if (hasPermission('web.metas.listar')) {
              next();
            } else {
              next('/');
            }
          }
        }
      ]
    },
    {
      path: 'ponto-critico',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Ponto Crítico',
            name: 'PontoCritico'
          }
        ]
      },
      name: 'PontoCritico',
      component: () => import('modules/goals/criticPoint/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.visualizar_ponto_critico')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'CvsList',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Listagem de CVs',
            name: 'Listagem de CVs'
          }
        ]
      },
      name: 'CvsList',
      component: () => import('modules/goals/CvsList/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.visualizar_validacao_cvs')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'validacao-cvs',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Validação CVs',
            name: 'ValidacaoCVS'
          }
        ]
      },
      name: 'ValidacaoCVS',
      component: () => import('modules/goals/CvValidation/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.visualizar_validacao_cvs')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'detalhes-cvs/:placeId/:supervisorId',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Detalhes CV',
            name: 'DetalhesCV'
          }
        ]
      },
      name: 'DetalhesCV',
      component: () => import('modules/goals/CvValidation/DetailPage.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.visualizar_validacao_cvs')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'indicar-ponto',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Indicar Ponto Critico',
            name: 'IndicarPontoCritico'
          }
        ]
      },
      name: 'IndicarPontoCritico',
      component: () => import('modules/goals/indicateCriticalPoint/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.visualizar_indicar_ponto')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'meta-minima',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Configurar Meta Mínima',
            name: 'MetaMinima'
          }
        ]
      },
      name: 'MetaMinima',
      component: () => import('modules/goals/minimumGoal/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.criar_meta_minima')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/parametrizacao',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Parametrizar Metas',
            name: 'Parametrizacao'
          }
        ]
      },
      name: 'Parametrizacao',
      component: () => import('modules/goals/distribuition/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.visualizar_parametrizacao')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'meta-minima-formulario',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Configurar Meta Mínima',
            name: 'MetaMinima'
          },
          {
            text: 'Nova Meta Mínima',
            name: 'MetaMinimaForm'
          }
        ]
      },
      name: 'MetaMinimaForm',
      component: () => import('modules/goals/minimumGoal/Form.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.criar_meta_minima')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'meta-minima-edicao',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Configurar Meta Mínima',
            name: 'MetaMinima'
          },
          {
            text: 'Editar Meta Mínima',
            name: 'MetaMinimaEdit'
          }
        ]
      },
      name: 'MetaMinimaEdit',
      component: () => import('modules/goals/minimumGoal/FormEdit.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.criar_meta_minima')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'business-plan',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Business Plan',
            name: 'BusinessPlan'
          }
        ]
      },
      name: 'BusinessPlan',
      component: () => import('modules/goals/BusinessPlan/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.criar_bp')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'business-plan/adicionar',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Business Plan',
            name: 'BusinessPlan'
          },
          {
            text: 'Novo Business Plan',
            name: 'BusinessPlanAdd'
          }
        ]
      },
      name: 'BusinessPlanAdd',
      component: () => import('modules/goals/BusinessPlan/AddPlan.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.criar_bp')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'business-plan/editar/:id',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Business Plan',
            name: 'BusinessPlan'
          },
          {
            text: 'Editar Business Plan',
            name: 'BusinessPlanEdit'
          }
        ]
      },
      name: 'BusinessPlanEdit',
      component: () => import('modules/goals/BusinessPlan/EditPlan.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.criar_bp')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'metas-adicionais/listar',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Calibração e Metas Adicionais',
            name: 'AdditionalGoals'
          }
        ]
      },
      name: 'AdditionalGoals',
      component: () => import('modules/goals/additionalGoals/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.listar') && hasPermission('web.metas.criar_metas_adicionais')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'baseline/listar',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Acompanhamento de Meta',
            name: 'baselineList'
          }
        ]
      },
      name: 'baselineList',
      component: () => import('modules/goals/baseline/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.metas.baseline_lista')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'baseline/acompanhar-metas',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Metas',
            name: 'PainelMetas'
          },
          {
            text: 'Acompanhamento de Metas',
            name: 'baselineList'
          },
          {
            text: 'Acompanhar Meta',
            name: 'followGoal'
          }
        ]
      },
      name: 'followGoal',
      component: () => import('modules/goals/baseline/FollowGoal.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (!to.params.id) {
          next({ name: 'baselineList' });
        }
        if (hasPermission('web.metas.listar')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'configurador-produto',
      component: () => import('modules/goals/productSettings/Index.vue'),
      children: [
        {
          path: '',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Metas',
                name: 'PainelMetas'
              },
              {
                text: 'Configurador de Produtos',
                name: 'ProductSettings'
              }
            ]
          },
          name: 'ProductSettings',
          component: () => import('modules/goals/productSettings/ListEdit.vue'),
          // eslint-disable-next-line
          beforeEnter: (to, from, next) => {
            if (hasPermission('web.metas.configuracao_produto')) {
              next();
            } else {
              next('/');
            }
          }
        }
      ]
    },
    {
      path: 'aprovacao-transferencia-metas',
      component: () => import('modules/goals/goalTransferApproval/Index.vue'),
      children: [
        {
          path: '',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Metas',
                name: 'PainelMetas'
              },
              {
                text: 'Aprovação de Transfêrencia de Metas',
                name: 'GoalTransferApproval'
              }
            ]
          },
          name: 'GoalTransferApproval',
          component: () => import('modules/goals/goalTransferApproval/List.vue'),
          beforeEnter: (to, from, next) => {
            if (hasPermission('web.metas.aprovacao_metas')) {
              next();
            } else {
              next('/');
            }
          }
        }
      ]
    },
    {
      path: 'distribuicao-metas',
      component: () => import('modules/goals/goalsTransfer/Index.vue'),
      children: [
        {
          path: '',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Metas',
                name: 'PainelMetas'
              },
              {
                text: 'Solicitar Ajuste entre Canais',
                name: 'GoalsTransfer'
              }
            ]
          },
          name: 'GoalsTransfer',
          component: () => import('modules/goals/goalsTransfer/List.vue'),
          // eslint-disable-next-line
          beforeEnter: (to, from, next) => {
            if (hasPermission('web.metas.distribuicao_metas')) {
              next();
            } else {
              next('/');
            }
          }
        }
      ]
    },
    {
      path: 'validacao-de-metas',
      component: () => import('modules/goals/goalsValidation/Index.vue'),
      children: [
        {
          path: '',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Metas',
                name: 'PainelMetas'
              },
              {
                text: 'Validação e Ajuste de Metas',
                name: 'GoalsValidation'
              }
            ]
          },
          name: 'GoalsValidation',
          // eslint-disable-next-line
          beforeEnter: (to, from, next) => {
            if (hasPermission('web.metas.validacao_metas')) {
              next();
            } else {
              next('/');
            }
          }
        }
      ]
    },
    {
      path: 'validacao-de-metas/validacao-hq',
      component: () => import('modules/goals/goalsValidation/HQValidation/Index.vue'),
      children: [
        {
          path: '',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Metas',
                name: 'PainelMetas'
              },
              {
                text: 'Validação e Ajuste de Metas',
                name: 'GoalsValidation'
              },
              {
                text: 'Validação HQ',
                name: 'HQValidation'
              }
            ]
          },
          name: 'HQValidation',
          component: () => import('modules/goals/goalsValidation/HQValidation/List.vue'),
          // eslint-disable-next-line
          beforeEnter: (to, from, next) => {
            if (hasPermission('web.metas.validacao_metas')) {
              next();
            } else {
              next('/');
            }
          }
        }
      ]
    },
    {
      path: 'validacao-de-metas/validacao-planejamento',
      component: () => import('modules/goals/goalsValidation/planningGoalValidation/Index.vue'),
      children: [
        {
          path: '',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Metas',
                name: 'PainelMetas'
              },
              {
                text: 'Validação de Metas',
                name: 'GoalsValidation'
              },
              {
                text: 'Validação Planejamento',
                name: 'PlanningGoalsValidation'
              }
            ]
          },
          name: 'PlanningGoalsValidation',
          component: () => import('modules/goals/goalsValidation/planningGoalValidation/List.vue'),
          // eslint-disable-next-line
          beforeEnter: (to, from, next) => {
            if (hasPermission('web.metas.planning_validacao_metas')) {
              next();
            } else {
              next('/');
            }
          }
        }
      ]
    },
    {
      path: 'distribuicao-entre-pdvs',
      component: () => import('modules/goals/distributionBetweenPDVS/Index.vue'),
      children: [
        {
          path: '',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Metas',
                name: 'PainelMetas'
              },
              {
                text: 'Executar Distribuição e Importar Metas',
                name: 'DistributionBetweenPDVS'
              }
            ]
          },
          name: 'DistributionBetweenPDVS',
          component: () => import('modules/goals/distributionBetweenPDVS/List.vue'),
          // eslint-disable-next-line
          beforeEnter: (to, from, next) => {
            if (hasPermission('web.metas.transferencias_entre_pdvs')) {
              next();
            } else {
              next('/');
            }
          }
        }
      ]
    },
    {
      path: 'metas-antigas',
      component: () => import('modules/goals/OldGoals/Index.vue'),
      children: [
        {
          path: '',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Metas',
                name: 'PainelMetas'
              },
              {
                text: 'Metas Antigas',
                name: 'OldGoals'
              }
            ]
          },
          name: 'OldGoals',
          component: () => import('modules/goals/OldGoals/List.vue')
        }
      ]
    }
  ]
};
